import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Grid,
  Avatar,
  Chip,
  IconButton,
  Card,
  CardContent,
} from "@mui/material";
import { Add, Delete, CloudUpload, ColorLens } from "@mui/icons-material";
import { layoutCSS } from "../component/common/commonStyle";

const RCSbot = () => {
  const [botData, setBotData] = useState({
    botType: "Domestic",
    botName: "",
    shortMessage: "",
    primaryPhone: {
      country: "India",
      code: "+91",
      number: "",
    },
    primaryEmail: "",
    emailLabel: "",
    primaryWebsite: "",
    termsUrl: "https://www.example.com",
    languages: [],
    agreeToTerms: false,
    messageTypes: {
      otp: false,
      promotional: false,
      transactional: false,
    },
    brandName: "",
    color: "#000000",
  });

  const [phoneNumbers, setPhoneNumbers] = useState([""]);
  const [emails, setEmails] = useState([{ email: "", label: "" }]);

  const handleInputChange = (field, value) => {
    setBotData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handlePhoneChange = (index, value) => {
    const newPhones = [...phoneNumbers];
    newPhones[index] = value;
    setPhoneNumbers(newPhones);
  };

  const handleEmailChange = (index, field, value) => {
    const newEmails = [...emails];
    newEmails[index] = {
      ...newEmails[index],
      [field]: value,
    };
    setEmails(newEmails);
  };

  const addPhoneNumber = () => {
    setPhoneNumbers([...phoneNumbers, ""]);
  };

  const addEmail = () => {
    setEmails([...emails, { email: "", label: "" }]);
  };

  const removePhoneNumber = (index) => {
    if (phoneNumbers.length > 1) {
      const newPhones = phoneNumbers.filter((_, i) => i !== index);
      setPhoneNumbers(newPhones);
    }
  };

  const removeEmail = (index) => {
    if (emails.length > 1) {
      const newEmails = emails.filter((_, i) => i !== index);
      setEmails(newEmails);
    }
  };

  const handleMessageTypeChange = (type) => {
    setBotData((prev) => ({
      ...prev,
      messageTypes: {
        ...prev.messageTypes,
        [type]: !prev.messageTypes[type],
      },
    }));
  };

  return (
    <Box sx={layoutCSS}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{ p: 3, mb: 3, backgroundColor: "primary.main", color: "white" }}
        >
          <Typography variant="h4" gutterBottom>
            RCS Panel
          </Typography>
          <Typography variant="h6" gutterBottom>
            Fab Mediatech
          </Typography>
        </Paper>

        <Grid container spacing={4}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            {/* Bot Type */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Bot Type
                </Typography>
                <FormControl fullWidth>
                  <Select
                    value={botData.botType}
                    onChange={(e) =>
                      handleInputChange("botType", e.target.value)
                    }
                  >
                    <MenuItem value="Domestic">Domestic</MenuItem>
                  </Select>
                </FormControl>
              </CardContent>
            </Card>

            {/* Bot Name */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Bot Name *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Enter the name of the bot that the user will see at the top of
                  the message thread.
                </Typography>
                <TextField
                  fullWidth
                  value={botData.botName}
                  onChange={(e) => handleInputChange("botName", e.target.value)}
                  placeholder="Enter bot name"
                  inputProps={{ maxLength: 40 }}
                  helperText={`${botData.botName.length}/40`}
                />
              </CardContent>
            </Card>

            {/* Bot Logo */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Bot Logo *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Provide a logo for your bot that will be displayed in
                  connection with the bot's name.
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<CloudUpload />}
                  component="label"
                  fullWidth
                  sx={{ py: 2 }}
                >
                  Choose
                  <input type="file" hidden />
                </Button>
              </CardContent>
            </Card>

            {/* Short Message */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Short Message *
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={botData.shortMessage}
                  onChange={(e) =>
                    handleInputChange("shortMessage", e.target.value)
                  }
                  placeholder="Enter short message"
                  inputProps={{ maxLength: 25 }}
                  helperText={`${botData.shortMessage.length}/25`}
                />
              </CardContent>
            </Card>

            {/* Primary Phone Number */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Primary Phone Number
                </Typography>

                {/* Primary Phone */}
                <Box sx={{ mb: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel>Country</InputLabel>
                        <Select
                          value={botData.primaryPhone.country}
                          onChange={(e) =>
                            handleInputChange("primaryPhone", {
                              ...botData.primaryPhone,
                              country: e.target.value,
                            })
                          }
                          label="Country"
                        >
                          <MenuItem value="India">India</MenuItem>
                          <MenuItem value="Centry">Centry</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        value={botData.primaryPhone.code}
                        onChange={(e) =>
                          handleInputChange("primaryPhone", {
                            ...botData.primaryPhone,
                            code: e.target.value,
                          })
                        }
                        label="Code"
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        fullWidth
                        value={botData.primaryPhone.number}
                        onChange={(e) =>
                          handleInputChange("primaryPhone", {
                            ...botData.primaryPhone,
                            number: e.target.value,
                          })
                        }
                        label="Phone Number"
                        placeholder="Phone Number 1"
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Additional Phone Numbers */}
                {phoneNumbers.map((phone, index) => (
                  <Box key={index} sx={{ mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={9}>
                        <TextField
                          fullWidth
                          value={phone}
                          onChange={(e) =>
                            handlePhoneChange(index, e.target.value)
                          }
                          placeholder={`Phone Number ${index + 2}`}
                          inputProps={{ maxLength: 25 }}
                          helperText={`${phone.length}/25`}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <IconButton
                          onClick={() => removePhoneNumber(index)}
                          color="error"
                          disabled={phoneNumbers.length === 1}
                        >
                          <Delete />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>
                ))}

                <Button
                  startIcon={<Add />}
                  onClick={addPhoneNumber}
                  variant="outlined"
                  size="small"
                >
                  Add Another Phone
                </Button>
              </CardContent>
            </Card>

            {/* Primary Email */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Primary Email
                </Typography>

                {emails.map((emailData, index) => (
                  <Box key={index} sx={{ mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          value={emailData.email}
                          onChange={(e) =>
                            handleEmailChange(index, "email", e.target.value)
                          }
                          placeholder={`Email ${index + 1}`}
                          label="Email"
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          value={emailData.label}
                          onChange={(e) =>
                            handleEmailChange(index, "label", e.target.value)
                          }
                          placeholder={`Email Label ${index + 1}`}
                          label="Label"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <IconButton
                          onClick={() => removeEmail(index)}
                          color="error"
                          disabled={emails.length === 1}
                        >
                          <Delete />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>
                ))}

                <Button
                  startIcon={<Add />}
                  onClick={addEmail}
                  variant="outlined"
                  size="small"
                >
                  Add Another Email
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6}>
            {/* Primary Website */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Primary Website
                </Typography>
                <TextField
                  fullWidth
                  value={botData.primaryWebsite}
                  onChange={(e) =>
                    handleInputChange("primaryWebsite", e.target.value)
                  }
                  placeholder="Website 1"
                />
              </CardContent>
            </Card>

            {/* Terms of Use URL */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Terms of Use URL *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Enter the URL of the website
                </Typography>
                <TextField
                  fullWidth
                  value={botData.termsUrl}
                  onChange={(e) =>
                    handleInputChange("termsUrl", e.target.value)
                  }
                  placeholder="https://www.example.com"
                />
              </CardContent>
            </Card>

            {/* Language Supported */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Language Supported *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Please specify the languages supported by the bot
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Select languages..."
                  // You can replace this with a multi-select component
                />
              </CardContent>
            </Card>

            {/* Agreement Checkbox */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={botData.agreeToTerms}
                      onChange={(e) =>
                        handleInputChange("agreeToTerms", e.target.checked)
                      }
                    />
                  }
                  label="I agree to launch the bot on all Indian carriers."
                />
              </CardContent>
            </Card>

            {/* Bot Message Type */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Bot Message Type
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={botData.messageTypes.otp}
                        onChange={() => handleMessageTypeChange("otp")}
                      />
                    }
                    label="OTP"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={botData.messageTypes.promotional}
                        onChange={() => handleMessageTypeChange("promotional")}
                      />
                    }
                    label="Promotional"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={botData.messageTypes.transactional}
                        onChange={() =>
                          handleMessageTypeChange("transactional")
                        }
                      />
                    }
                    label="Transactional"
                  />
                </Box>
              </CardContent>
            </Card>

            {/* Brand Name */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Brand Name *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Enter the brand name with which your bot will be associated.
                </Typography>
                <TextField
                  fullWidth
                  value={botData.brandName}
                  onChange={(e) =>
                    handleInputChange("brandName", e.target.value)
                  }
                  placeholder="Select Brand"
                />
              </CardContent>
            </Card>

            {/* Banner Image */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Banner Image *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Provide a brand image for your bot that will be displayed in
                  the bot's 'info & options' screen. Note: Your logo will be
                  overlaid on the Banner image (bottom centre) so be careful
                  with your design.
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<CloudUpload />}
                  component="label"
                  fullWidth
                  sx={{ py: 2 }}
                >
                  Choose
                  <input type="file" hidden />
                </Button>
              </CardContent>
            </Card>

            {/* Color */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Color *
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Specify a color for your agent with a minimum 4.51 contrast
                  ratio relative to white.
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <TextField
                    value={botData.color}
                    onChange={(e) => handleInputChange("color", e.target.value)}
                    placeholder="#000000"
                    sx={{ flex: 1 }}
                  />
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: botData.color,
                      border: "1px solid #ccc",
                      borderRadius: 1,
                    }}
                  />
                  <IconButton>
                    <ColorLens />
                  </IconButton>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <Box
          sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 4 }}
        >
          <Button variant="outlined" size="large">
            Cancel
          </Button>
          <Button variant="contained" size="large">
            Create
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default RCSbot;
